(function($) {
    'use strict';
    var $window = $(window);

    $('.mod_navigation').find('a.submenu').click(function(e) {
        if ($window.width() >= 900) {
            return true;
        }

        var $this = $(this);

        if ($this.is('.active, .trail')) {
            return true;
        }

        $this.addClass('trail');
        $this.siblings('ul').slideDown(400);

        return false;
    });

    $('.mod_navigation').find('strong.submenu, span.submenu').click(function(e) {
        if ($window.width() >= 900) {
            return true;
        }

        $(this).toggleClass('trail')
            .siblings('ul')
            .slideToggle(400);

        return false;
    });

})(jQuery);